const TAMANHO_CNPJ_SEM_DV = 12;
const REGEX_CARACTERES_FORMATACAO = /[./-]/g;
const REGEX_FORMACAO_BASE_CNPJ = /^[A-Z\d]{12}$/;
const REGEX_FORMACAO_DV = /^\d{2}$/;
const REGEX_VALOR_ZERADO = /^[0]+$/;

const VALOR_BASE = '0'.charCodeAt(0);
const PESOS_DV = [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];

function removeCaracteresFormatacao(cnpj) {
    return cnpj.trim().replace(REGEX_CARACTERES_FORMATACAO, '');
}

function isCnpjFormacaoValidaSemDV(cnpj) {
    return REGEX_FORMACAO_BASE_CNPJ.test(cnpj) && !REGEX_VALOR_ZERADO.test(cnpj);
}

function isCnpjFormacaoValidaComDV(cnpj) {
    const base = cnpj.substring(0, 12);
    const dv = cnpj.substring(12);
    return cnpj.length === 14
        && REGEX_FORMACAO_BASE_CNPJ.test(base)
        && REGEX_FORMACAO_DV.test(dv)
        && !REGEX_VALOR_ZERADO.test(cnpj);
}

function calculaDigito(cnpj) {
    let soma = 0;
    for (let indice = cnpj.length - 1; indice >= 0; indice--) {
        const valorCaracter = cnpj.charCodeAt(indice) - VALOR_BASE;
        soma += valorCaracter * PESOS_DV[PESOS_DV.length - cnpj.length + indice];
    }
    return soma % 11 < 2 ? 0 : 11 - (soma % 11);
}

export function calculaDV(baseCnpj) {
    if (baseCnpj != null) {
        baseCnpj = removeCaracteresFormatacao(baseCnpj);
        if (isCnpjFormacaoValidaSemDV(baseCnpj)) {
            const dv1 = String(calculaDigito(baseCnpj));
            const dv2 = String(calculaDigito(baseCnpj + dv1));
            return dv1 + dv2;
        }
    }
    throw new Error(`CNPJ ${baseCnpj} não é válido para o cálculo do DV`);
}

export function isCNPJ(cnpj) {
    if (cnpj != null) {
        cnpj = removeCaracteresFormatacao(cnpj).toUpperCase();
        if (isCnpjFormacaoValidaComDV(cnpj)) {
            const dvInformado = cnpj.substring(TAMANHO_CNPJ_SEM_DV);
            const dvCalculado = calculaDV(cnpj.substring(0, TAMANHO_CNPJ_SEM_DV));
            return dvCalculado === dvInformado;
        }
    }
    return false;
}